import { render } from "./Performance.vue?vue&type=template&id=c8bfcca6"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__